import { config } from '@/lib/env-helpers';
import { ApolloClient, from, createHttpLink, split } from '@apollo/client';
import { authLink } from './auth-link';
import { errorLink } from './error-link';
import { cache } from './cache';
import { retryLink } from './retry-link';
import { getMainDefinition } from '@apollo/client/utilities';
import { subscriptionLink } from './subscription-link';
import { memberRoleLink } from './links/member-role-link';
import { suspendedAccountLink } from './links/suspended-account-link';

const httpLink = createHttpLink({
  uri: config.API_ENDPOINT,
});

/**@see 
   https://www.apollographql.com/docs/react/data/subscriptions#3-split-communication-by-operation-recommended
-- queries and mutations will use HTTP as normal, and subscriptions will use WebSocket.
**/

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  subscriptionLink, // if request is subscription
  httpLink // else
);

function apolloClient() {
  return new ApolloClient({
    cache,
    link: from([suspendedAccountLink, memberRoleLink, authLink, retryLink, errorLink, splitLink]),
  });
}

export default apolloClient;
